<template>
    <el-dialog
            v-if="meta.isHumtogAdministrator"
            title="New Channel"
            :visible="visible"
            :width="isMobile ? '99%' : '600px'"
            @close="close"
            append-to-body
            class="user-select submit-form"
    >
        <el-alert v-if="customError" :title="customError" class="margin-bottom-1" type="error"></el-alert>

        <el-alert :title="warning" type="warning"></el-alert>

        <el-form label-position="top" label-width="10px">
            <el-form-item label="Title">
                <el-input
                        placeholder="Title..."
                        name="title"
                        v-model="title"
                        autocorrect="off"
                        autocapitalize="off"
                ></el-input>
                <el-alert v-if="errors" v-for="e in errors.title" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>


            <el-form-item label="Slug">
                <el-input
                        placeholder="Name..."
                        name="name"
                        v-model="name"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                ></el-input>

                <el-alert
                        show-icon
                        :closable="false"
                        title="Slugs must be alpha-numeric, with no spaces. They're also not editable so make up your mind before continue! Examples: Politics-India, Politics-Global etc"
                        type="info"
                ></el-alert>

                <el-alert v-for="e in errors.name" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>
            <el-form-item label="Tag Line">
                <el-input
                        placeholder="Tag Line..."
                        name="name"
                        v-model="tagLine"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                ></el-input>

                <!--<el-alert show-icon
                                  :closable="false"
                                  title="Names must be alpha-numeric, with no spaces. They're also not editable so make up your mind before continue! Examples: gaming, news, OldSchoolCool, modernWarfare2"
                                  type="info">
                </el-alert>-->

                <el-alert v-for="e in errors.tagline" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>
            <el-form-item label="Rules">
                <el-input
                        type="textarea"
                        placeholder="A few word to describe your rules for community..."
                        name="rules"
                        :autosize="{ minRows: 4, maxRows: 10}"
                        v-model="rules"
                ></el-input>

                <el-alert
                        show-icon
                        :closable="false"
                        :title="'The Rules field helps users to submit feed according to community rules.'"
                        type="info"
                ></el-alert>

                <el-alert v-for="e in errors.rules" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>

            <el-form-item label="Description">
                <el-input
                        type="textarea"
                        placeholder="A few word to describe your channel..."
                        name="description"
                        :autosize="{ minRows: 4, maxRows: 10}"
                        v-model="description"
                ></el-input>

                <el-alert
                        show-icon
                        :closable="false"
                        :title="'The description field helps users find your channel. The first few words matter the most!'"
                        type="info"
                ></el-alert>

                <el-alert v-for="e in errors.description" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>
            <el-form-item label="Location">
                <el-select v-model="value8" filterable placeholder="Select Location">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
                <el-alert v-for="e in errors.location" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>
            <el-form-item label="Related Communities">
                <el-select
                        v-model="value10"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="Choose tags for your article"
                >
                    <el-option
                            v-for="item in options5"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
                <el-alert v-for="e in errors.relatedchannel" :title="e" type="error" :key="e"></el-alert>
            </el-form-item>
            <!-- NSFW Toggle -->
            <el-checkbox v-model="sfw">Safe for work</el-checkbox>
        </el-form>

        <span slot="footer" class="dialog-footer">
      <el-button
              round
              type="success"
              @click="submit"
              :disabled="!validates"
              :loading="loading"
              size="medium"
      >Create</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import Helpers from "../mixins/Helpers";

    export default {
        props: ["visible"],

        mixins: [Helpers],

        data() {
            return {
                name: "",
                title: "",
                description: "",
                tagLine: "",
                rules: "",
                sfw: true,
                errors: [],
                customError: "",
                loading: false,
                options: [],
                value8: "",
                options5: [],
                value10: [],
                warning: `At the current stage, we're trying to keep the channels number short, making it easier for new users. Thus, please do a little search before creating your channel to make sure a similar one doesn't already exist. `
            };
        },

        watch: {
            visible() {
                if (this.visible) {
                    window.location.hash = "newChannel";
                } else {
                    if (window.location.hash == "#newChannel") {
                        history.go(-1);
                    }
                }
            }
        },

        computed: {
            validates() {
                return this.name.trim() && this.description.trim();
            }
        },
        created() {
            axios
                .get("/location")
                .then(response => this.location(response))
                .catch(error => this.errorLocation(error));
            axios
                .get("/get-all-channels")
                .then(response => this.channel(response))
                .catch(error => this.errorChannel(error));
        },

        methods: {
            channel(response) {
                if (response.status == 200) {
                    var result = response.data.data.map(item => ({
                        label: item.name,
                        value: item.id
                    }));

                    this.options5 = result;
                }
            },
            errorChannel(error) {
            },
            location(response) {
                if (response.status == 200) {
                    var result = response.data.data.map(item => ({
                        label: item.name,
                        value: item.id
                    }));

                    this.options = result;
                }
            },
            errorLocation(error) {
            },
            close() {
                this.$emit("update:visible", false);
            },

            submit() {
                // this.loading = true;

                axios
                    .post("/channels", {
                        title: this.title,
                        name: this.name,
                        tagline: this.tagLine,
                        rules: this.rules,
                        description: this.description,
                        relatedchannel: this.value10,
                        location: this.value8,
                        nsfw: !this.sfw
                    })
                    .then(response => {
                        this.errors = [];

                        // let's add the categoriy_id to the user's moderatingAt and administratorAt
                        Store.state.moderatingAt.push(response.data.data.id);
                        Store.state.administratorAt.push(response.data.data.id);
                        Store.state.moderatingChannels.push(response.data.data);
                        Store.state.subscribedChannels.push(response.data.data);
                        Store.state.subscribedAt.push(response.data.data.id);
                        Store.page.channel.temp = response.data.data;

                        this.$router.push(
                            "/c/" + response.data.data.name + "/mod/settings?created=1"
                        );

                        this.loading = false;
                        this.reset();
                        this.close();
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;

                        this.loading = false;
                    });
            },

            reset() {
                this.name = "";
                this.description = "";
                this.sfw = true;
                this.errors = [];
                this.customError = "";
                this.loading = false;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NewChannel.vue